import { useEffect, useState } from "react";

const memoryData = {};

export default function useMemoryState(key, initialState) {
  const [state, setState] = useState(memoryData[key] ? memoryData[key] : initialState);

  useEffect(() => {
    memoryData[key] = state;
  }, [state, key]);

  return [state, setState];
}
